module.exports = "/_next/static/images/1706918c6fe74cd0cfbbfc41d933833a-creditsprd-xs.jpg";